module.exports = __webpack_public_path__ + "img/Calming Presence.8ef90f7f.svg";